/* ============================================================
   OIKOS ANTALIS — Global behaviour
   Subtle, purposeful. Nothing gratuitous.
   ============================================================ */
(function () {
  "use strict";

  /* ---- Header: transparent over hero, solid on scroll / non-hero ---- */
  const header = document.querySelector(".site-header");
  if (header) {
    const hasHero = document.body.classList.contains("has-hero");
    const onScroll = () => {
      const solid = !hasHero || window.scrollY > window.innerHeight * 0.7;
      header.classList.toggle("is-solid", solid);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Scroll reveal ---- */
  const reveals = document.querySelectorAll("[data-reveal]");
  if (reveals.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add("is-in"));
  }

  /* ---- Language switcher ---- */
  const lang = document.querySelector("[data-lang]");
  if (lang) {
    const btn = lang.querySelector(".lang__btn");
    const menu = lang.querySelector(".lang__menu");
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const open = menu.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", String(open));
    });
    document.addEventListener("click", () => {
      menu.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
    });
  }

  /* ---- Mobile nav drawer ---- */
  const toggle = document.querySelector(".nav-toggle");
  const drawer = document.querySelector("[data-drawer]");
  if (toggle && drawer) {
    const setOpen = (open) => {
      drawer.classList.toggle("is-open", open);
      document.body.classList.toggle("nav-locked", open);
      drawer.setAttribute("aria-hidden", String(!open));
      toggle.setAttribute("aria-expanded", String(open));
    };
    toggle.addEventListener("click", () => setOpen(!drawer.classList.contains("is-open")));
    drawer.querySelectorAll("[data-drawer-close]").forEach((el) =>
      el.addEventListener("click", () => setOpen(false))
    );
    drawer.querySelectorAll(".drawer__nav a").forEach((a) =>
      a.addEventListener("click", () => setOpen(false))
    );
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) setOpen(false);
    });
  }
})();
